<template>
  <div>
    <label v-if="label" class="form-label" :for="id">{{ label }} <span v-if="required">*</span> :</label>
    <vue-multiselect
      v-model="modelValue" :placeholder="placeholder" :max-height="150" :options="formattedOptions"
      :multiple="true" track-by="id" label="name" :close-on-select="false" :select-label="$t('multiselect.press-enter')"
      :deselect-label="$t('multiselect.remove-enter')"
    />
    <hint :hint="hint" />
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import VueMultiselect from 'vue-multiselect'
import debounce from 'lodash/debounce'
import Hint from '@/Shared/Hint'

export default {
  name: 'SelectMultiple',
  components: {VueMultiselect, Hint},
  props: {
    modelValue: Array,
    defaultOptions: Array,
    id: {
      type: String,
    },
    value: Object,
    label: String,
    error: String,
    placeholder: String,
    hint: String,
    required: Boolean,
  },
  setup(props, context) {
    const updateValue = (event) => {
      context.emit('update:modelValue', event)
    }
    return { updateValue }
  },
  data() {
    return {
      loading: false,
      selected: this.value,
      options: [],
    }
  },
  computed: {
    formattedOptions(){
      return this.defaultOptions
    },
  },
  watch: {
    modelValue(selected) {
      this.updateValue(selected)
    },
  },
  mounted() {
    if (this.modelValue) {
      this.options = this.modelValue
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    handleSearch: debounce(function (searchQuery) {
      this.fetchData(searchQuery)
    }, 500),
    addTag (newTag) {
      this.options.push(newTag)
    },
  },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
